module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/actions/request-pending/request-pending.component.scss
// module id = ./src/app/limit-flow-proposal/component/actions/request-pending/request-pending.component.scss
// module chunks = main